import React from "react";
import Icon from "components/Elements/Icon/Icon.tsx";
import { useModal } from "contexts/modalContext/modalContext.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import Button from "components/Elements/Button/Button.js";

interface IWrongFilesFormatModalProps {
  filesNames: string[];
  culture: string;
  callback: () => void;
}

const WrongFilesFormatModal = ({
  filesNames,
  culture,
  callback,
}: IWrongFilesFormatModalProps) => {
  const { closeModal } = useModal();
  const { getTextByKey, getHtmlByKey } = useContent();

  const returnDirection = () => {
    if (culture === "he-IL" || culture === "ar-SA") {
      return "rtl";
    } else {
      return "ltr";
    }
  };

  return (
    <div
      className={`embed-form-error-modal embed-form-error-modal-${returnDirection()}`}
      style={{ direction: returnDirection() }}
    >
      <div className="exit" onClick={() => closeModal()}>
        <Icon name="x" />
      </div>
      <div className="content-error-form">
        <div className="error-image">
          <Icon name="cloud-embed-error" ext="svg" />
        </div>
        <div className="error-text">
          {getHtmlByKey("upload-jumboform-error-text")}
          <ul className="removed-files-list">
            {filesNames.map((file) => {
              return <li>{file}</li>;
            })}
          </ul>
        </div>
        <div className="error-ok-button">
          <Button
            className="new-button"
            onClick={() => {
              closeModal();
              callback();
            }}
          >
            {getTextByKey("error-jumboform-ok-button")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WrongFilesFormatModal;
